import { useEffect, useMemo, useState } from 'react';
import { ViewController } from 'foundations-components/transitional/components/ViewController';
//@ts-expect-error Untyped import
import { getDataType } from 'reporting-data/public/get-data-type';
//@ts-expect-error Untyped import
import getProperties from 'reporting-data/properties';
import { getEditorSchemasMapFromConfig } from '../common/editorUtils';
import { getPresetLabel, validatePresetConfiguration } from './presetsEditorUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const BasePresetsEditor = props => {
  const {
    report,
    onChange,
    strategy: editorStrategy,
    schema: editorSchema
  } = props;
  const {
    options: presetOptions
  } = editorSchema;
  const [propertyDefinitions, setPropertyDefinitions] = useState({});
  const dataType = getDataType(report);
  useEffect(() => {
    getProperties(dataType).then(dataTypeProperties => {
      setPropertyDefinitions(dataTypeProperties.get(dataType).toJS());
    }).catch();
  }, [dataType]);
  const editorSchemaMap = useMemo(() => getEditorSchemasMapFromConfig(report), [report]);
  const validatedPresetsMap = useMemo(() => {
    return presetOptions.reduce((validPresets, preset) => {
      const presetStrategy = editorStrategy.presetStrategies[preset.type];
      const validatedPresetValue = presetStrategy && validatePresetConfiguration(preset, editorSchemaMap);
      if (!validatedPresetValue) {
        return validPresets;
      }
      validPresets[preset.type] = preset;
      return validPresets;
    }, {});
  }, [presetOptions, editorSchemaMap, editorStrategy.presetStrategies]);
  const presetUIOptions = useMemo(() => Object.keys(validatedPresetsMap).map(presetType => ({
    text: getPresetLabel(presetType),
    value: presetType
  })), [validatedPresetsMap]);

  // if for some reason a preset isn't valid, don't render this editor at all
  if (presetUIOptions.length !== presetOptions.length) {
    return null;
  }
  return /*#__PURE__*/_jsx(ViewController, {
    "data-test-id": "report-editor-presets-editor",
    size: "extra-small",
    onChange: ({
      target: {
        value
      }
    }) => {
      const preset = validatedPresetsMap[value];
      if (preset) {
        onChange(editorStrategy.presetStrategies[preset.type].updateReport(report, preset, propertyDefinitions, editorSchemaMap));
      }
    },
    options: presetUIOptions,
    marginBlock: "400"
  });
};